import * as React from 'react';
import {
  Button,
  Dialog, DialogActions, DialogTitle,
  Typography,
} from '@material-ui/core';

interface MarkingModalProps {
  barcode?: string;
  showModal: boolean;
  onClose: () => void;
  dialogReason?: 'label' | 'value'
}

const MarkingModal: React.FC<MarkingModalProps> = (
  {
    barcode = '', showModal, onClose, dialogReason = 'label',
  },
) => {
  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog open={showModal}>
      <DialogTitle>
        <Typography variant="overline">
          {'CURRENT REPAIR · '}
          {barcode}
        </Typography>
        <Typography variant="h5" id="dialog-header">
          {dialogReason === 'value'
            ? 'An item value is required for the repair to be marked.'
            : 'A label is required for the first repair item.'}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {dialogReason === 'value'
            ? 'Update repair with item value to continue saving.'
            : 'Update repair item with label and continue saving.'}
        </Typography>
      </DialogTitle>
      <DialogActions>
        <Button color="primary" variant="contained" onClick={handleCancel}>{'CONTINUE'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MarkingModal;
